import React, { useState } from "react";
import "../contract.css"

const CreateContrcatStep1 = ({ handleStep }) => {

  const contentArr = [
    { label: "Course content" },
    { label: "Creator Led-contract" },
    { label: "Original Content" },
    { label: "Sponsored content" },
  ];
  const [currentPassword, setCurrentPassword] = useState("");

  const [showSidebar, setShowSidebar] = useState(false);
  const [content, setContent] = useState("");
   


  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };
  return (
    <>
      <div class="g-sidenav-show  bg-gray-100 min-vh-100">
        <div id="wrapper">
          {/* <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} /> */}
          <main className="main-content border-radius-lg">
            {/* <Topbar handleSidebar={handleSidebar} /> */}
            <div>
              {/* <div className="header header-bg pb-6">
                <div className="container-fluid">
                  <div className="header-body">
                    <div className="row align-items-center py-4">
                      <div className="col-lg-6 col-7">
                        <nav
                          aria-label="breadcrumb"
                          className="d-none d-md-inline-block ml-md-4"
                        >
                          <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                            <li className="breadcrumb-item">
                              <Link to="/dashboard">
                                <i className="fas fa-home" />
                              </Link>
                            </li>
                            <li className="breadcrumb-item">
                              <Link to="/update-password"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Update Password</span></Link>
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="container-fluid Contrcat-conatiner">
                <div className="row">
                  <div className="col">
                    <div className="card mb-4">
                      <div className="card-header">
                        <h5 className="mb-0">Create Contract</h5>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="contract-label">Project Name *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="New Contract"
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                value={currentPassword}
                              />
                            </div>

                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="contract-label">
                                Contract Type *
                              </label>
                              <div>
                                <select
                                  className="form-select contrcat-input "
                                  aria-label="Default select example"
                                  value={content}
                                  onChange={(e) => setContent(e.target.value)}
                                >
                                  <option value="">Select Contract</option>
                                  {contentArr.map((item, index) => (
                                    <option key={index} value={item.label}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>

                              </div>
                            </div>
                          </div>
                        </div>

                        <button onClick={handleStep}
                          className="btn submit-btn-contract mt-4"

                        >
                          <span>Submit</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default CreateContrcatStep1;
